import React, { useMemo,useEffect } from "react";
import ReactDOM from "react-dom/client";
import 'react-quill/dist/quill.snow.css';
import "jsvectormap/dist/css/jsvectormap.css";
import 'react-toastify/dist/ReactToastify.css';
import 'react-modal-video/css/modal-video.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import "react-bootstrap-typeahead/css/Typeahead.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { TourProvider, useTour } from "@reactour/tour";
import { Button } from "react-bootstrap"; 
import { Icon } from "@iconify/react/dist/iconify.js"; // Importing Iconify
import {initializeApp} from 'firebase/app'
import "./pages/TourStyles.css"; // Custom styles for animations

import { getDatabase } from "firebase/database";
export const API_URL = "https://api.towrankers.com"
export const API_URL_LOCAL = "https://api.towrankers.com"
// export const API_URL_LOCAL = 'http://192.168.0.138:3001'
export const API_GOOGLE_KEY = "AIzaSyDIUOen5iR9Cc5oW3g93sRsU-Z-UR__HYY"
 // const { isLoaded } = useJsApiLoader({
  //   googleMapsApiKey: "AIzaSyDIUOen5iR9Cc5oW3g93sRsU-Z-UR__HYY",
  //   libraries: ["places"],
  // });
  export function formatDateAccordingTo(dateString) {
    // Handle null or invalid date strings
    if (!dateString) {
      return '';
    }
    const date = new Date(dateString);
    if (isNaN(date.getTime())) {
      return '';
    }
  
    // Get the current date
    const currentDate = new Date();
  
    // Check if the date matches the current date
    const isToday =
      date.getFullYear() === currentDate.getFullYear() &&
      date.getMonth() === currentDate.getMonth() &&
      date.getDate() === currentDate.getDate();
  
    // Format the date based on whether it matches the current date
    if (isToday) {
      // Format as time only (e.g., 10:10 AM)
      return new Intl.DateTimeFormat('en-US', {
        hour: 'numeric',
        minute: 'numeric',
        hour12: true,
      }).format(date);
    } else {
      // Format as date and time (e.g., 12 Mar 2025 10:10 AM)
      return new Intl.DateTimeFormat('en-US', {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        hour12: true,
      }).format(date);
    }
  }
  
  const steps = [
    {
      selector: "#add-truck-btn",
      content: () => (
        <div className="tour-step">
          {/* <Icon icon="mdi:truck" className="tour-icon" />  */}
          <h4 className="title">Add Your First Truck</h4>
          <p>Click the button below to add a new truck to your fleet.</p>
        </div>
      ),
    },
    {
      selector: "#drivers-section",
      content: () => (
        <div className="tour-step">
          {/* <Icon icon="mdi:account-group" className="tour-icon" /> */}
          <h4 className="title">Manage Your Drivers</h4>
          <p>View and assign drivers to different jobs here.</p>
        </div>
      ),
    },
    {
      selector: "#jobs-section",
      content: () => (
        <div className="tour-step">
          {/* <Icon icon="mdi:briefcase" className="tour-icon" /> */}
          <h4 className="title">Assign Jobs</h4>
          <p>Assign jobs to your drivers and track progress.</p>
        </div>
      ),
    },
    {
      selector: "#dashboard",
      content: () => (
        <div className="tour-step">
          {/* <Icon icon="mdi:view-dashboard" className="tour-icon" /> */}
          <h4 className="title">Dashboard Overview</h4>
          <p>Monitor all activities from your main dashboard.</p>
        </div>
      ),
    },
  ];
  
  // const TourControls = () => {
    
  
  //   useEffect(() => {
  //     const hasSeenTour = localStorage.getItem("hasSeenTour");
  //     if (!hasSeenTour) {
  //       setTimeout(() => setIsOpen(true), 1000);
  //     }
  //   }, [setIsOpen]);
  
  //   const handleNext = () => {
  //     if (currentStep < steps.length - 1) {
  //       setCurrentStep((prev) => prev + 1);
  //     } else {
  //       alert('peased')
  //       localStorage.setItem("hasSeenTour", "true");
  //       setIsOpen(false);
  //     }
  //   };
  
  //   const handlePrev = () => {
  //     setCurrentStep((prev) => (prev > 0 ? prev - 1 : 0));
  //   };
  
  //   return (
  //     <>
  //       {isOpen && (
  //         <div className="custom-tour fade-in slide-up">
  //           <div className="tour-content">
  //             <div className="tour-buttons">
  //               {currentStep > 0 && (
  //                 <Button variant="secondary" onClick={handlePrev}>
  //                   Previous
  //                 </Button>
  //               )}
  //               <Button variant="primary" onClick={handleNext}>
  //                 {currentStep < steps.length - 1 ? "Next" : "Finish"}
  //               </Button>
  //             </div>
  //           </div>
  //         </div>
  //       )}
  //     </>
  //   );
  // };

  const firebaseConfig = {
    apiKey: "AIzaSyC8HHWP5cP2bdc8dvyXuVrXcYNK0hWyzoM",
    authDomain: "rankersapp-e52cb.firebaseapp.com",
    databaseURL: "https://rankersapp-e52cb-default-rtdb.firebaseio.com",
    projectId: "rankersapp-e52cb",
    storageBucket: "rankersapp-e52cb.firebasestorage.app",
    messagingSenderId: "1024520500827",
    appId: "1:1024520500827:web:ead6dfec0bc26a9bac717e",
    measurementId: "G-HD983CM569"
  };
  
  const firebase = initializeApp(firebaseConfig);
  export const db = getDatabase(firebase);
const root = ReactDOM.createRoot(document.getElementById("root"));
// const { currentStep, setCurrentStep, isOpen, setIsOpen } = useTour();
root.render(
  <>
   {/* <TourProvider steps={steps} onClickClose={()=>localStorage.setItem('hasSeenTour' , 'true')}> */}
      {/* <TourControls/> */}
       <App />
    {/* </TourProvider> */}
  
    </>
);

reportWebVitals();
